import React from "react";
import { Link } from "react-router-dom";
import others from "../../assets/img/empty.png"


function Others({isOpen, onDimHover, subCategories, selectedCategory, onMenuClick}){

  if (!isOpen) return null;

  return(
    <div>
      {/* others 드롭다운 메뉴 */}
      <div className="dropdown_menu header_ctg others_drop">
        <div style={{width: '100%', background: 'rgb(255, 255, 255)'}} onMouseLeave={onDimHover}>
          <div className="inner">

            <div className="brand_navi others_navi">
              <div className="main_tit">{selectedCategory}</div>
                <ul className="others_list">

                  {subCategories.map((subCategory, index) => (
                  <li key={index}>
                    <Link 
                      to={`/category/cinemaPageSec?title=${subCategory.category_name}&mainCategory=${selectedCategory}&category_code=${subCategory.category_code}`}
                        onClick={() => {
                          if (onMenuClick) onMenuClick(selectedCategory);
                          if (onDimHover) onDimHover(); // 클릭 후 드롭다운 닫기
                        }}
                    >
                      <img 
                        src={subCategory.mobile_img_url || others}
                        alt={subCategory.category_name} 
                        className="object-contain"
                        loading="lazy"
                      />
                      <span className="sub_tit">{subCategory.category_name}</span>
                    </Link>
                  </li>
                ))}
                </ul>
            </div>
          </div>
        </div>
        <div className="menu_dim"></div>
      </div>
    </div>
  )
};

export default Others;